const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})
window.dataLayer = window.dataLayer || []

const pushEventAdd = function (event, name, productNumber, price, brand) {
  let formattedPrice = formatPrice(price)
  let variant = checkVariant(name)
  window.dataLayer.push({
    'event': event,
    'ecommerce': {
      'currencyCode': 'EUR',
      'add': {
        'products': [{
          'name': name,
          'id': productNumber,
          'price': formattedPrice,
          'brand': brand,
          'category': 'Tarif',
          'categoryId': '',
          'variant': variant,
          'quantity': 1
        }]
      }
    }
  })
}

const pushEventCheckout = function (event, step, name, productNumber, price, brand) {
  let formattedPrice = formatPrice(price)
  let variant = checkVariant(name)
  let stepNumber = getStepNo(step)
  window.dataLayer.push({
    'event': event,
    'ecommerce': {
      'currencyCode': 'EUR',
      'checkout': {
        'actionField': {'step': stepNumber},
        'products': [{
          'name': name,
          'id': productNumber,
          'price': formattedPrice,
          'brand': brand,
          'category': 'Tarif',
          'categoryId': '',
          'variant': variant,
          'quantity': 1
        }]
      }
    }
  })
}

const pushEventPurchase = function (event, clientContractId, name, shippingCosts, productNumber, price, brand) {
  let formattedPrice = formatPrice(price)
  let formattedShippingCosts = formatPrice(shippingCosts)
  let variant = checkVariant(name)
  let tax = calculateTax(price)
  window.dataLayer.push({
    'event': event,
    'revenueNetto': 'revenueNetto',
    'ecommerce': {
      'currencyCode': 'EUR',
      'purchase': {
        'actionField': {
          'id': clientContractId,
          'revenue': formattedPrice,
          'tax': tax,
          'shipping': formattedShippingCosts,
          'coupon': ''
        },
        'products': [{
          'name': name,
          'id': productNumber,
          'price': formattedPrice,
          'brand': brand,
          'category': 'Tarif',
          'categoryId': '',
          'variant': variant,
          'quantity': 1,
          'coupon': ''
        }]
      }
    }
  })
}

const checkVariant = function (name) {
  let variant = '';
  if (name.includes('Smart')) {
    variant = name.match(/Smart-Paket\s(XS|S|M|L)/);
    return variant[1]
  }
  return variant
}

const getStepNo = function (step) {
  let stepNumber = 0
  if (step === 'options') {
    stepNumber = 1
  }
  if (step === 'personalData') {
    stepNumber = 2
  }
  if (step === 'payment') {
    stepNumber = 3
  }
  if (step === 'summary') {
    stepNumber = 4
  }
  return stepNumber
}

const formatPrice = function (price) {
  return formatter.format(parseInt(price) / 100)
}

const calculateTax = function (price) {
  price = formatPrice(price)
  let net = price / 1.19
  let tax = net * 0.19
  return formatter.format(tax)
}

export default {
  methods: {
    pushEventAdd,
    pushEventCheckout,
    pushEventPurchase
  }
}
